import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'La primera vez que usé el paso 1 me sorprendí a mí misma. No grité. Solo dije "veo que estás muy frustrado" y algo cambió en su cara. No fue magia, pero fue completamente diferente a todo lo que había intentado antes.',
    name: 'María G.',
    photo: 'https://cdn.magicpatterns.com/uploads/6nhU9uXw3LFaJEycYrxaYB/resena_2_berrinches.png',
    description: 'Mamá de Tomás, 4 años'
  }, {
    text: 'Lo leí en el avión de regreso a casa y esa misma noche lo apliqué. Mi hijo tuvo una crisis por el baño y en lugar de escalar, bajó en menos de 5 minutos. No lo podía creer.',
    name: 'Carlos R.',
    photo: 'https://cdn.magicpatterns.com/uploads/9VL3MQqEsMiRgSLmBFyEeQ/resena_1_berrinches.png',
    description: 'Papá de dos niños, 3 y 6 años'
  }, {
    text: 'Lo que más me ayudó fue entender que mi hijo no me desafiaba a propósito. Eso solo ya cambió cómo me siento cuando empieza una crisis.',
    name: 'Valentina M.',
    photo: 'https://cdn.magicpatterns.com/uploads/2JtonAZPEiuSDMGc1w69x1/resena_4_berrinches.png',
    description: 'Mamá de Sofía, 5 años'
  }, {
    text: 'El capítulo de los primeros 30 segundos me abrió los ojos. Yo era la que escalaba todo sin darme cuenta. Ahora tengo una pausa antes de hablar.',
    name: 'Andrea L.',
    photo: 'https://cdn.magicpatterns.com/uploads/tBPLVfESMLMhE5hFH4UaCp/resena_3_berrinches.png',
    description: 'Mamá de Lucas, 3 años'
  }];
  return <section className="py-24 px-6 bg-brand-cream" data-id="element-348">
      <div className="max-w-6xl mx-auto" data-id="element-349">
        <FadeIn data-id="element-350">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-351">
            Lo que dicen madres y padres que ya lo aplicaron
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-352">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-353">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col" data-id="element-354">
                <div className="flex gap-1 mb-4" data-id="element-355">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-orange text-brand-orange" data-id="element-356" />)}
                </div>
                <p className="text-gray-700 leading-relaxed mb-6 flex-1 italic" data-id="element-357">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100" data-id="element-358">
                  <img src={testimonial.photo} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-brand-sage/30 flex-shrink-0" data-id="element-359" />
                  <div data-id="element-360">
                    <p className="font-bold text-gray-900" data-id="element-361">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-362">
                      {testimonial.description}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-363">
          <div className="bg-white p-8 rounded-2xl text-center border-2 border-brand-sage max-w-2xl mx-auto" data-id="element-364">
            <div className="flex justify-center gap-1 mb-3" data-id="element-365">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-brand-orange text-brand-orange" data-id="element-366" />)}
            </div>
            <p className="text-2xl font-bold text-gray-900" data-id="element-367">
              +847 familias ya están usando
              <br data-id="element-368" />
              el Protocolo Calma 3 Minutos
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}